module.exports = __webpack_public_path__ + "static/Canopy-523ebf230e36e00300bb626b1f08488b.jpg";